/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';
import { Text } from './Text';
import { Title } from './Title';

const RebalanceFailed = () => {
  const { t } = useTranslation();
  return (
    <>
      <Icon type={'sadFace'} />
      <Title>{t('NOTIFICATION_REBALANCE_FAILED__title')}</Title>
      <Text>{t('NOTIFICATION_REBALANCE_FAILED__desc')}</Text>
    </>
  );
};

export { RebalanceFailed };
